var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "650px", width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Search")]),
          ]),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("r-search-kind", {
                        attrs: { model: _vm.kind, label: "Type:" },
                        on: {
                          "update:model": function ($event) {
                            _vm.kind = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.kind.id === 1
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "12" } },
                        [
                          _c("r-item-table", {
                            attrs: { items: _vm.model.items, title: "Items" },
                            on: {
                              "update:items": function ($event) {
                                return _vm.$set(_vm.model, "items", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "12" } },
                        [_c("v-divider")],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _vm.model.items.length > 0
                    ? _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("r-search-filter", {
                            attrs: { model: _vm.filter, label: "Filter:" },
                            on: {
                              "update:model": function ($event) {
                                _vm.filter = $event
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.model.kind && _vm.model.kind.id && _vm.model.kind.id === 1
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-3",
                            attrs: {
                              label: "Search Lowest Level",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.model.searchLowestLevel,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "searchLowestLevel", $$v)
                              },
                              expression: "model.searchLowestLevel",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        [
                          _c("v-checkbox", {
                            staticClass: "mt-3",
                            attrs: {
                              label: "Exclude Sourcing",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.model.excludeSourcing,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "excludeSourcing", $$v)
                              },
                              expression: "model.excludeSourcing",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.kind.id === 1
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4", sm: "4" } },
                        [
                          _c("r-point", {
                            attrs: {
                              label: "Arrow Offset",
                              model: _vm.model.offset,
                              "hide-details": "",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "offset", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "8", md: "8" } },
                        [
                          _c("r-tutorial-dropdown", {
                            attrs: {
                              model: _vm.model.tutorial,
                              clearable: true,
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "tutorial", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.kind.id === 3
                ? _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "4", sm: "4" } },
                        [
                          _c("r-tile", {
                            attrs: {
                              label: "Tile",
                              model: _vm.model.tile,
                              "hide-details": "",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "tile", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.save },
                },
                [_vm._v("Save")]
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }